import React, { useEffect, useMemo, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { OnChange } from 'react-final-form-listeners';
import { useFormState, useForm } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';

import QCXFinalNumericDecimalField from '../../../../shared-components/final-numeric-decimal-field/QCXFinalNumericDecimalField'; // float

export default function NumeroReal({
  metadado, 
  isConsult,
  basePath="",
  ncm=false,
  ...restProps
}) {
  const [label, setLabel] = useState("")
  const [name,  setName] = useState("")
  const [obrigatorio, setObrigatorio] = useState(false);
  const [codigo, setCodigo] = useState("");
  const form = useForm();

  useEffect(() => {
    if (!ncm) {
      setName(`atributosAdicionais.lpcoForm.jsonFormulario.${metadado?.codigo}.valor`)
    } else {
      setName(`atributosAdicionais.lpcoForm.jsonFormulario.ncm.dados.${metadado?.codigo}.valor`)
    }
    
    setLabel(metadado?.nome);
    setObrigatorio(metadado?.validacao?.obrigatorio || false);
  }, [metadado])

  if(!name) {
      return null
  }

  return (
    <Grid item xs={12} sm={6} md={4}>
      <QCXFinalNumericDecimalField
        id={codigo}
        key={codigo}
        name={name}
        label={label}
        disabled={isConsult}
        scale={5}
        required={obrigatorio}
        {...restProps}
      />
    </Grid>
  );
}
